module.exports = __webpack_public_path__ + "assets/aae79651dc656c6540efa47f9df6e5c8.mp3";